import { services } from '../services/index.js';
import { eventEmitter } from "../utils/eventEmitter/index.js";
import { deleteCookie } from '../utils/cookies.js';
import { notificationController } from "@/utils/notifications";
export const profileStore = {
    _profile: undefined,
    set profile(profile) {
        this._profile = profile;
        eventEmitter.emit('auth status update', { data: { LoggedIn: this.isLoggedIn } });
    },
    get profile() {
        return this._profile;
    },
    get isLoggedIn() {
        return !!this.profile;
    },
    setIsPremium(status) {
        this.profile.isPremium = status;
        eventEmitter.emit('isPremium change', { data: { isPremium: status } });
    },
    async loadUser() {
        const response = await services.profile.loadProfile();
        if (response.status === 200)
            this.profile = await response.json();
        return response;
    },
    signUp(data) {
        return services.profile.signUp(data);
    },
    signIn(data) {
        return services.profile.signIn(data)
            .then(async (response) => {
            const res = await response.json();
            if (!response.ok) {
                notificationController.show({ type: 'error', content: res.message });
                throw new Error();
            }
            this.profile = res;
            return response;
        });
    },
    async verify(verificationToken) {
        const response = await services.profile.verify(verificationToken);
        return response.ok;
    },
    signOut() {
        services.profile.signOut();
        deleteCookie('accessTokenTwo');
        deleteCookie('user_id');
        this.profile = null;
    },
    async updateProfile(data) {
        return services.profile.updateProfile(data);
    },
    restorePassword(data) {
        return services.profile.restorePassword(data);
    }
};
